export const buildImagePath = function (imageName) {
  return '/web-hosting/assets/images/' + imageName;
};
